import axios from 'axios';

const BASE = process.env.REACT_APP_BASE_URL || '/mlapi';

export const ConsentService = {
    getSettings: async (recruitmentId, language) => {
        const { data } = await axios.get(`${BASE}/chat/consent-settings/${recruitmentId}`, { params: { language } });
        return data;
    },
    getPrivacyPolicy: async (recruitmentId) => {
        const { data } = await axios.get(`${BASE}/chat/privacy-policy/${recruitmentId}`);
        return data;
    },
    record: async (payload) => {
        await axios.post(`${BASE}/chat/consents`, payload);
    },
};
